import useMeQuery from '@hooks/queries/useMeQuery';
import useAuthStore from '@src/stores/authStore';

export default function useCurrentResidenceReservationUrlQuery(options) {
  const { residenceId } = useAuthStore();

  return useMeQuery({
    select: (user) => {
      const r = user?.residences?.find((res) => res.id === residenceId);
      return r?.reservation_module_url ?? r?.reservationModuleUrl ?? null;
    },
    ...options,
  });
}
